import { render } from "./ShowMoreFilters.vue?vue&type=template&id=132d8324&ts=true"
import script from "./ShowMoreFilters.vue?vue&type=script&lang=ts"
export * from "./ShowMoreFilters.vue?vue&type=script&lang=ts"

import "./ShowMoreFilters.vue?vue&type=style&index=0&id=132d8324&lang=scss"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__